import React from 'react';
import EditLanguageComponent from '../../../Components/Language/EditLanguage';

export default function EditLanguage() {
    return (
        <div className='page-body'>
            <EditLanguageComponent />
        </div>
    );
}